import { useQuery } from '@tanstack/react-query';

import { api } from '../client';
import { queryKeys } from './keys';
import type { VersionInfo } from '../types';

/** The release the app runs; a deploy is a new page load, so one read per visit is enough. */
export function useVersion() {
  return useQuery({
    queryKey: queryKeys.version,
    queryFn: () => api<VersionInfo>('/api/version'),
    staleTime: Infinity,
  });
}
